import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_GATEWAY_WEBHOOK_VERIFICATION = defineFcm('gateway_webhook_verification')
	.asJson(z.record(z.string(), z.boolean()))
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: 'payment-service',
		context: 'Payment gateway webhooks',
		description:
			'Per-gateway kill switch for webhook verification in payment_service, keyed by gateway name (e.g. stripe, chargebee). Verification runs unless a gateway key is explicitly false.',
		template: { chargebee: true, stripe: true },
	});
